import React, { useEffect, useState } from 'react';
import {
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
  Grid,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IntegrationCard from '../common/IntegrationCard';
import { useAuth } from 'services/auth';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';

const IntegrationTab = () => {
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { getCurrentLoggedUserParams } = useAuth();
  const emailAddress = 'digital@salonemilano.it';
  const [userParams, setUserParams] = useState(null);
  const i18n = translations.MatchMakingV2(intl).integration;

  const fetchUserParams = async () => {
    try {
      const data = await getCurrentLoggedUserParams();
      setUserParams(data);
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    fetchUserParams();
  }, []);

  if (!userParams) return null;

  const cardData = [
    {
      image: `/themes/custom/sdm/images/icon-salesforce.svg`,
      title: i18n.cards.salesforce.title,
      subtitle: i18n.cards.salesforce.text,
      buttonText: userParams.salesforce
        ? i18n.cards.buttonText2
        : i18n.cards.buttonText,
      linkText: i18n.cards.linkText,
      linkHref: i18n.cards.linklurlSalesforce,
      buttonIcon: <OpenInNewIcon />,
      buttonVariant: userParams.salesforce ? 'outlined' : 'contained',
      hrefButton: userParams.salesforce
        ? `mailto:${emailAddress}`
        : `https://login.salesforce.com/packaging/installPackage.apexp?p0=04td20000002r0D`,
      buttonId: userParams.salesforce ? '' : 'id-salesforce-1',
      chipText: userParams.salesforce ? i18n.cards.crm.chip : '',
    },
    {
      image: `/themes/custom/sdm/images/icon-hubspot.svg`,
      title: i18n.cards.hubspot.title,
      subtitle: i18n.cards.hubspot.text,
      buttonText: userParams.hubspot
        ? i18n.cards.buttonText2
        : i18n.cards.buttonText,
      linkText: i18n.cards.linkText,
      linkHref: i18n.cards.linklurlHubspot,
      buttonIcon: <OpenInNewIcon />,
      buttonVariant: userParams.hubspot ? 'outlined' : 'contained',
      hrefButton: userParams.hubspot
        ? `mailto:${emailAddress}`
        : `https://crm-hs.salonemilano.it/?federationId=${userParams.field_federationid_salesforce}`,
      buttonId: userParams.hubspot ? '' : 'id-hubspot',
      chipText: userParams.hubspot ? i18n.cards.crm.chip : '',
    },
    {
      title: i18n.cards.crm.title,
      subtitle: i18n.cards.crm.text,
      buttonText: i18n.cards.crm.buttonText,
      buttonVariant: 'outlined',
      hrefButton: `mailto:${emailAddress}`,
      chipText: userParams.hubspot ? i18n.cards.crm.chip : '',
    },
  ];

  return (
    <>
      <Stack
        alignItems={isMobile ? 'center' : 'flex-start'}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="subheadling"
          sx={{ textAlign: isMobile ? 'center' : 'left', fontWeight: 600 }}
        >
          {i18n.title}
        </Typography>
        <Typography
          variant="body"
          sx={{ textAlign: isMobile ? 'center' : 'left' }}
        >
          {i18n.subtitle}
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        {cardData.map((card, index) => (
          <Grid item xs={12} md={4} key={index}>
            <IntegrationCard {...card} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default IntegrationTab;
